/** Seeded PRNG (mulberry32). Deterministic randomness for tests, fuzzing and generators. */
export type Rand = () => number

export function mulberry32(seed: number): Rand {
  let a = seed >>> 0
  return () => {
    a = (a + 0x6d2b79f5) >>> 0
    let t = a
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/** Crypto-backed uniform [0,1) for production use. */
export const cryptoRand: Rand = () => {
  const b = new Uint32Array(1)
  crypto.getRandomValues(b)
  return b[0]! / 4294967296
}

export function pick<T>(rand: Rand, items: readonly T[]): T {
  if (items.length === 0) throw new Error('pick from empty list')
  return items[Math.floor(rand() * items.length)]!
}

export function int(rand: Rand, min: number, max: number): number {
  return min + Math.floor(rand() * (max - min + 1))
}
